export const getCareProviderCount = (state) =>
    state.careProvider.careProviders.maxCount;